import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const setIsConnectivity = (isConnectivity: boolean): Action<FirmsActions> => {
  return createAction(FirmsActions.setIsConnectivity, isConnectivity);
};
